import { render, staticRenderFns } from "./membersListComponent.vue?vue&type=template&id=94b84518&scoped=true"
import script from "./membersListComponent.vue?vue&type=script&lang=js"
export * from "./membersListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b84518",
  null
  
)

export default component.exports